import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { INK, NEUTRAL, STATUS, STATUS_BADGE } from "../../theme/tokens";
import { IssuePriority } from "../../utils/models";

const PriorityChip = styled(Chip)(({ theme }) => ({
	borderRadius: "16px",
	height: "24px",
	fontSize: "14px",
	fontWeight: 500,
	padding: "2px 2px",
	border: "none",
	backgroundColor: NEUTRAL[50],
	color: INK.SECONDARY,
	"&.selected": {
		border: `1px solid ${INK.SECONDARY}`,
		backgroundColor: NEUTRAL[50],
		color: INK.SECONDARY,
		fontWeight: 600,
	},
}));

export const PriorityChips = React.memo(
	({
		selectedPriority,
		handlePriorityChange,
		priorityCounts,
	}: {
		selectedPriority: IssuePriority | "all";
		handlePriorityChange: (priority: IssuePriority | "all") => void;
		priorityCounts: any;
	}) => (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
				width: "100%",
			}}
		>
			<PriorityChip
				className={`all-priorities ${selectedPriority === "all" ? "selected" : ""}`}
				label={`All (${priorityCounts.all})`}
				onClick={() => handlePriorityChange("all")}
			/>
			<PriorityChip
				className={`high ${selectedPriority === IssuePriority.TopPriority ? "selected" : ""}`}
				icon={
					<span
						style={{
							width: 8,
							height: 8,
							borderRadius: "50%",
							backgroundColor: STATUS.ERROR.main,
						}}
					/>
				}
				label={`High (${priorityCounts.high})`}
				onClick={() => handlePriorityChange(IssuePriority.TopPriority)}
			/>
			<PriorityChip
				className={`medium ${selectedPriority === IssuePriority.Important ? "selected" : ""}`}
				icon={
					<span
						style={{
							width: 8,
							height: 8,
							borderRadius: "50%",
							backgroundColor: STATUS_BADGE.AMBER_INK,
						}}
					/>
				}
				label={`Medium (${priorityCounts.medium})`}
				onClick={() => handlePriorityChange(IssuePriority.Important)}
			/>
			<PriorityChip
				className={`low ${selectedPriority === IssuePriority.Optional ? "selected" : ""}`}
				icon={
					<span
						style={{
							width: 8,
							height: 8,
							borderRadius: "50%",
							backgroundColor: STATUS_BADGE.BRAND_FALLBACK,
						}}
					/>
				}
				label={`Low (${priorityCounts.low})`}
				onClick={() => handlePriorityChange(IssuePriority.Optional)}
			/>
		</Box>
	),
);
